import { PipeSeparator } from "client/Components";
import { PropsWithChildren, ReactElement } from "react";
import { CategoryList } from "./CategoryList";
import styles from "./HubSubtitleWithCategories.module.less";

export type HubSubtitleWithCategoriesProps = {
	categoryNames: readonly string[];
};

export const HubSubtitleWithCategories = (
	props: PropsWithChildren<HubSubtitleWithCategoriesProps>
): ReactElement => {
	const {
		categoryNames,
		children
	} = props;

	const hasCategories: boolean = categoryNames.length > 0;

	return (
		<div className={styles.root}>
			<div className={styles.leftSide}>
				{children}
				{hasCategories && (
					<PipeSeparator />
				)}
			</div>
			{hasCategories && (
				<div className={styles.rightSide}>
					<CategoryList
						categories={categoryNames}
						shouldShowAtLeastOne
					/>
				</div>
			)}
		</div>
	);
};
HubSubtitleWithCategories.displayName = "HubSubtitleWithCategories";